// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__y-nJg","rightAdornment":"Header_rightAdornment__1K1Eu"};